export default function TableCell(theme) {
    return {
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                    padding: 12,
                    borderColor: theme.palette.divider,
                    '&:first-of-type': {
                        paddingLeft: 20
                    },
                    '& .MuiChip-root': {
                        height: 'auto',
                        width: 'min-content',
                        [theme.breakpoints.up('md')]: {
                            marginLeft: '5px'
                        }
                    }
                },
                head: {
                    fontWeight: 600
                }
            }
        }
    };
}
